import React, { useState, useEffect, memo, Fragment } from 'react'
import prop from 'ramda/src/prop'
import classNames from 'classnames'
import moment from 'moment-mini'
import withStyles from '@material-ui/core/styles/withStyles'
import { likeEnum, likeStatusEnum } from 'root/src/shared/constants/enums'
import getLikedState from 'root/src/shared/util/getLikedState'
import LikeIcon from 'root/src/client/public/icons/ic-thumb-up'
import DislikeIcon from 'root/src/client/public/icons/ic-thumb-down'
import ddAnonImage from 'root/src/client/public/dd-anon-image.jpg'
import { commentKey } from 'root/src/shared/constants/keys'
import getIdFromKey from 'root/src/shared/util/getIdFromKey'
import ReplyForm from './ReplyForm'
import ExpandButton from './ExpandButton'
import { commentStyle } from './styles'
import SignInPrompt from './SignInPrompt'
// eslint-disable-next-line import/no-cycle
import CommentsList from './index'

const Comment = memo((props) => {
	const {
		commentData,
		userId,
		isAdmin,
		classes,
		auditCommentLikes,
		deleteComment,
		userData,
		addCommentReply,
		isMobileRes,
		getCommentReplies,
		setOpenMessage,
		openMessageId,
		isAuthenticated,
	} = props

	const [replyFormOpen, setReplyFormOpen] = useState(false)
	const [repliesOpen, setRepliesOpen] = useState(false)
	const [signInPromptVisible, setSignInPrompt] = useState(false)

	useEffect(() => {
		if (openMessageId === prop('messageId', commentData)) {
			return setSignInPrompt(true)
		}
		return setSignInPrompt(false)
	})

	const {
		message, created,
		messageId, parentId, listStoreKey,
		image, displayName, replies = [], projectId, messageType,
		repliesAmount, likes = [], dislikes = [],
	} = commentData

	const likedState = getLikedState(userId, commentData)
	const username = displayName || 'Anonymous'
	const remainingReplies = repliesAmount - replies.length

	const auditCommentLike = (likeStatus) => {
		if (!isAuthenticated) return setOpenMessage(prop('messageId', commentData))
		return (
			auditCommentLikes({
				audit: likeStatus,
				messageId,
				parentId,
				messageType,
			}))
	}

	return (
		<li className={classNames('layout-row', classes.root)}>
			<div className={classes.imageContainer}>
				<div
					className={classes.image}
					style={{
						backgroundImage: `url(${image || ddAnonImage})`,
					}}
				/>
			</div>
			<div className={classes.commentWrapper}>
				<div className={classes.userMeta}>
					<span className={classes.bolder}>{username}</span>
					<span className={classes.metaText}>{moment(created).fromNow()}</span>
				</div>
				<p className={classes.comment}>{message}</p>
				<div className={classes.commentActions}>
					<button
						type="button"
						onClick={() => auditCommentLike(likeEnum.LIKE)}
						className={classNames(
							classes.commentAction,
							{ [classes.commentActionHover]: userId },
							{ [classes.likeActionActive]: likedState === likeStatusEnum.LIKED },
						)}
					>
						<LikeIcon style={{ marginBottom: 3 }} />
						<span className={classes.likeItemCount}>{likes.length}</span>
					</button>
					<button
						type="button"
						onClick={() => auditCommentLike(likeEnum.DISLIKE)}
						className={classNames(
							classes.commentAction,
							{ [classes.commentActionHover]: userId },
							{ [classes.likeActionActive]: likedState === likeStatusEnum.DISLIKED },
						)}
					>
						<DislikeIcon /><span className={classes.likeItemCount}>{dislikes.length}</span>
					</button>
					{userId && (
						<button
							type="button"
							onClick={() => setReplyFormOpen(!replyFormOpen)}
							className={classNames(
								classes.commentAction,
								classes.commentActionButton,
								{ [classes.likeActionActive]: replyFormOpen },
							)}
						>Reply
						</button>
					)}
					{isAdmin
						&& (
							<button
								type="button"
								onClick={() => deleteComment({
									parentId, messageId, projectId, messageType, listStoreKey,
								})}
								className={classNames(classes.commentAction, classes.commentActionButton)}
							>Delete comment
							</button>
						)
					}
				</div>
				{signInPromptVisible
					&& (
						<SignInPrompt
							signInPromptVisible={signInPromptVisible}
							className={classes.signInPrompt}
							text="to like and comment"
						/>
					)
				}
				<ReplyForm
					{...userData}
					open={replyFormOpen}
					startInput={`${username} `}
					isMobileRes={isMobileRes}
					repliesOpen={repliesOpen}
					setReplyFormOpen={setReplyFormOpen}
					setRepliesOpen={setRepliesOpen}
					addCommentReply={addCommentReply}
					messageId={messageType === commentKey ? messageId : getIdFromKey(parentId)}
				/>
				{(replies.length > 0 && repliesOpen)
					&& (
						<Fragment>
							<ExpandButton
								classes={classes}
								messageId={messageId}
								isHideButton
								text={`Hide ${replies.length} replies`}
								setRepliesOpen={setRepliesOpen}
							/>
							<CommentsList isReplies list={replies} commentProps={props} />
						</Fragment>
					)}
				{(
					remainingReplies > 0
					|| (replies.length === repliesAmount && repliesAmount > 0 && !repliesOpen)
				) && (
					<ExpandButton
						classes={classes}
						messageId={messageId}
						getCommentReplies={getCommentReplies}
						text={`View ${repliesOpen ? remainingReplies : repliesAmount}${replies.length > 0 ? ' more' : ''} replies`}
						setRepliesOpen={setRepliesOpen}
						hasReplies={replies.length > 0 && !repliesOpen}
					/>
				)}
			</div>
		</li>
	)
})

export default withStyles(commentStyle, { name: 'MuiComment' })(Comment)
